export const DNS_ZONE_INFO =
  'Select the DNS zone to automatically register a DNS record for this network. Ensure DNS is enabled and zones are configured.'

export const MAKE_SHARED_INFO = 'If checked, network will be available for every tenant.'

export enum NetworkType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}
